var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Preferences } from '@capacitor/preferences';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { navigateTo } from '@popup/multichain/actions/navigation.actions';
import { Screen } from 'src/reference-data/screen.enum';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
const formatTimestamp = (tmsmp) => {
    if (!tmsmp || isNaN(tmsmp))
        return 'N/A';
    const d = new Date(tmsmp);
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.${String(d.getMilliseconds()).padStart(3, '0')}`;
};
const formatDuration = (start, end) => {
    const diff = end - start;
    if (diff <= 0)
        return 'N/A';
    const mins = Math.floor(diff / 60000);
    const secs = Math.floor((diff % 60000) / 1000);
    const ms = diff % 1000;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}.${ms.toString().padStart(3, '0')}`;
};
const downloadTextFile = (content, filename) => {
    const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 2000);
};
const historyItemToText = (item) => {
    var _a, _b;
    const req = item.request;
    const res = item.result;
    const lines = [];
    lines.push(`Date: ${formatTimestamp(req.tmsmp)}`);
    if ((res === null || res === void 0 ? void 0 : res.endtime) && req.tmsmp != null) {
        lines.push(`Duration: ${formatDuration(req.tmsmp, res.endtime)}`);
    }
    lines.push(`Site: ${req.site}`);
    lines.push(`Chain: ${req.chain || 'steem'}`);
    lines.push(`User: ${req.username}`);
    lines.push(`Operation: ${req.action}`);
    lines.push(`Status: ${(_a = res === null || res === void 0 ? void 0 : res.status) !== null && _a !== void 0 ? _a : 'Unknown'}`);
    if (res) {
        lines.push(`Description: ${(_b = res.description) !== null && _b !== void 0 ? _b : ''}`);
        if (res.block_num != null)
            lines.push(`Block Number: ${res.block_num}`);
        if (res.trx_num != null)
            lines.push(`Transaction Number: ${res.trx_num}`);
        if (res.id)
            lines.push(`Tran. ID: ${res.id}`);
        if (res.ref_block_num != null)
            lines.push(`Ref Block Num: ${res.ref_block_num}`);
        if (res.ref_block_prefix != null)
            lines.push(`Ref Block Prefix: ${res.ref_block_prefix}`);
        if (res.operations && Array.isArray(res.operations) && res.operations.length > 0) {
            lines.push(`Operations (${res.operations.length}):`);
            res.operations.forEach((op, i) => {
                lines.push(`  ${i + 1}. ${op.type}`);
                Object.entries(op)
                    .filter(([k]) => k !== 'type')
                    .forEach(([k, v]) => {
                    lines.push(`     ${k}: ${typeof v === 'object' ? JSON.stringify(v) : String(v)}`);
                });
            });
        }
    }
    if (req.operation && typeof req.operation === 'object') {
        lines.push('Request operation:');
        lines.push(JSON.stringify(req.operation, null, 2));
    }
    return lines.join('\n');
};
const HistoryPage = ({ navigateTo }) => {
    const [history, setHistory] = useState([]);
    const [filteredHistory, setFilteredHistory] = useState([]);
    const [chains, setChains] = useState([]);
    const [users, setUsers] = useState([]);
    const [operations, setOperations] = useState([]);
    const [selectedChain, setSelectedChain] = useState('All');
    const [selectedUser, setSelectedUser] = useState('All');
    const [selectedOperation, setSelectedOperation] = useState('All');
    const [selectedStatus, setSelectedStatus] = useState('All');
    const [expandedItems, setExpandedItems] = useState({});
    useEffect(() => {
        const load = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const { value: reqVal } = yield Preferences.get({
                    key: 'processed_requests',
                });
                const { value: resVal } = yield Preferences.get({
                    key: 'operation_results',
                });
                const requests = reqVal
                    ? JSON.parse(reqVal).map((s) => JSON.parse(s))
                    : [];
                const results = resVal ? JSON.parse(resVal) : [];
                const items = requests
                    .map((req) => ({
                    request: req,
                    result: results.find((r) => r.tmsmp === req.tmsmp),
                }))
                    .sort((a, b) => (b.request.tmsmp || 0) - (a.request.tmsmp || 0));
                setHistory(items);
                setFilteredHistory(items);
                setChains([...new Set(requests.map((r) => r.chain || 'steem'))].sort());
                setUsers([...new Set(requests.map((r) => r.username))].sort());
                setOperations([...new Set(requests.map((r) => r.action))].sort());
            }
            catch (e) {
                console.error('Errore caricamento history', e);
            }
        });
        load();
    }, []);
    useEffect(() => {
        const filtered = history.filter((item) => {
            var _a;
            const chainOk = selectedChain === 'All' || item.request.chain === selectedChain;
            const userOk = selectedUser === 'All' || item.request.username === selectedUser;
            const opOk = selectedOperation === 'All' ||
                item.request.action === selectedOperation;
            const statusOk = selectedStatus === 'All' || ((_a = item.result) === null || _a === void 0 ? void 0 : _a.status) === selectedStatus;
            return chainOk && userOk && opOk && statusOk;
        });
        setFilteredHistory(filtered);
    }, [history, selectedChain, selectedUser, selectedOperation, selectedStatus]);
    const clearHistory = () => __awaiter(void 0, void 0, void 0, function* () {
        yield Preferences.remove({ key: 'processed_requests' });
        yield Preferences.remove({ key: 'operation_results' });
        setHistory([]);
        setFilteredHistory([]);
    });
    const toggleExpand = (idx, level) => {
        setExpandedItems((prev) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return (Object.assign(Object.assign({}, prev), { [idx]: {
                    firstLevel: level === 'first'
                        ? !((_b = (_a = prev[idx]) === null || _a === void 0 ? void 0 : _a.firstLevel) !== null && _b !== void 0 ? _b : false)
                        : ((_d = (_c = prev[idx]) === null || _c === void 0 ? void 0 : _c.firstLevel) !== null && _d !== void 0 ? _d : false),
                    secondLevel: level === 'second'
                        ? !((_f = (_e = prev[idx]) === null || _e === void 0 ? void 0 : _e.secondLevel) !== null && _f !== void 0 ? _f : false)
                        : ((_h = (_g = prev[idx]) === null || _g === void 0 ? void 0 : _g.secondLevel) !== null && _h !== void 0 ? _h : false),
                } }));
        });
    };
    const exportAllFiltered = () => {
        if (!filteredHistory.length)
            return;
        const header = `Operations History\n` +
            `Total: ${filteredHistory.length}\n` +
            `Filters: chain=${selectedChain}, user=${selectedUser}, op=${selectedOperation}, status=${selectedStatus}\n` +
            `${'='.repeat(40)}\n\n`;
        const body = filteredHistory
            .map((item) => historyItemToText(item))
            .join(`\n\n${'-'.repeat(40)}\n\n`);
        downloadTextFile(header + body + '\n', `ops-history_${Date.now()}.txt`);
    };
    const exportOneItem = (item) => {
        var _a, _b;
        downloadTextFile(historyItemToText(item) + '\n', `ops-history_${(_a = item.request.username) !== null && _a !== void 0 ? _a : 'user'}_${(_b = item.request.tmsmp) !== null && _b !== void 0 ? _b : Date.now()}.txt`);
    };
    const goBack = () => navigateTo === null || navigateTo === void 0 ? void 0 : navigateTo(Screen.HOME_PAGE);
    const selectStyle = {
        width: '100%',
        padding: '4px',
        borderRadius: '6px',
        border: '1px solid #ccc',
        fontSize: '0.85em',
        boxSizing: 'border-box',
        background: '#fff',
    };
    return (React.createElement("div", { style: {
            width: '100%',
            maxWidth: '100%',
            height: '100vh',
            background: '#fff',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            boxSizing: 'border-box',
        } },
        React.createElement("div", { style: {
                padding: '10px',
                flexShrink: 0,
                boxSizing: 'border-box',
                width: '100%',
            } },
            React.createElement(SVGIcon, { icon: SVGIcons.TOP_BAR_BACK_BTN, onClick: goBack, className: "button back-button", hoverable: true }),
            React.createElement("div", { style: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: '8px',
                } },
                React.createElement("h2", { style: { margin: 0, fontSize: '1.15em', flex: '1 1 auto' } }, "Operations History"),
                React.createElement("div", { style: { display: 'flex', gap: '6px', flexShrink: 0 } },
                    React.createElement("button", { onClick: exportAllFiltered, disabled: filteredHistory.length === 0, style: {
                            padding: '6px 10px',
                            background: filteredHistory.length === 0 ? '#ccc' : '#6d4aff',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: filteredHistory.length === 0 ? 'not-allowed' : 'pointer',
                            fontSize: '12px',
                            whiteSpace: 'nowrap',
                        }, title: "Save filtered list as .txt" }, "\uD83D\uDCC4 TXT"),
                    React.createElement("button", { onClick: clearHistory, style: {
                            padding: '6px 10px',
                            background: '#d32f2f',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '4px',
                            fontSize: '12px',
                            whiteSpace: 'nowrap',
                        } }, "Delete"))),
            React.createElement("div", { style: {
                    marginTop: '10px',
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '6px',
                } },
                React.createElement("div", null,
                    React.createElement("div", { style: {
                            fontSize: '0.8em',
                            color: '#444',
                            marginBottom: '2px',
                        } }, "Chain"),
                    React.createElement("select", { value: selectedChain, onChange: (e) => setSelectedChain(e.target.value), style: selectStyle },
                        React.createElement("option", { value: "All" }, "All"),
                        chains.map((c) => (React.createElement("option", { key: c, value: c }, c))))),
                React.createElement("div", null,
                    React.createElement("div", { style: {
                            fontSize: '0.8em',
                            color: '#444',
                            marginBottom: '2px',
                        } }, "User"),
                    React.createElement("select", { value: selectedUser, onChange: (e) => setSelectedUser(e.target.value), style: selectStyle },
                        React.createElement("option", { value: "All" }, "All"),
                        users.map((u) => (React.createElement("option", { key: u, value: u }, u))))),
                React.createElement("div", null,
                    React.createElement("div", { style: {
                            fontSize: '0.8em',
                            color: '#444',
                            marginBottom: '2px',
                        } }, "Operation"),
                    React.createElement("select", { value: selectedOperation, onChange: (e) => setSelectedOperation(e.target.value), style: selectStyle },
                        React.createElement("option", { value: "All" }, "All"),
                        operations.map((o) => (React.createElement("option", { key: o, value: o }, o))))),
                React.createElement("div", null,
                    React.createElement("div", { style: {
                            fontSize: '0.8em',
                            color: '#444',
                            marginBottom: '2px',
                        } }, "Status"),
                    React.createElement("select", { value: selectedStatus, onChange: (e) => setSelectedStatus(e.target.value), style: selectStyle },
                        React.createElement("option", { value: "All" }, "All"),
                        React.createElement("option", { value: "Ok" }, "Ok"),
                        React.createElement("option", { value: "Ko" }, "Ko"))))),
        React.createElement("div", { style: {
                flex: 1,
                overflowY: 'auto',
                padding: '10px',
                boxSizing: 'border-box',
                width: '100%',
            } }, filteredHistory.length === 0 ? (React.createElement("p", { style: { color: '#666' } }, "No History found")) : (filteredHistory.map((item, idx) => {
            var _a, _b, _c, _d, _e, _f, _g;
            const res = item.result;
            const isMulti = (res === null || res === void 0 ? void 0 : res.operations) &&
                Array.isArray(res.operations) &&
                res.operations.length > 0;
            return (React.createElement("div", { key: (_a = item.request.tmsmp) !== null && _a !== void 0 ? _a : idx, style: {
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    padding: '12px',
                    marginBottom: '12px',
                    backgroundColor: '#f9f9f9',
                    boxSizing: 'border-box',
                    width: '100%',
                    overflow: 'hidden',
                } },
                React.createElement("div", { style: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: '8px',
                        fontSize: '0.85em',
                        width: '100%',
                        boxSizing: 'border-box',
                    } },
                    React.createElement("div", { style: { minWidth: 0, overflow: 'hidden' } },
                        React.createElement("strong", null, "Date:"),
                        ' ',
                        React.createElement("span", { style: { wordBreak: 'break-word' } }, formatTimestamp(item.request.tmsmp)),
                        (res === null || res === void 0 ? void 0 : res.endtime) && item.request.tmsmp != null && (React.createElement("span", { style: { color: '#666' } },
                            ' ',
                            "(",
                            formatDuration(item.request.tmsmp, res.endtime),
                            ")"))),
                    React.createElement("div", { style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            flexShrink: 0,
                        } },
                        React.createElement("button", { type: "button", title: "Save this operation as .txt", onClick: (e) => {
                                e.stopPropagation();
                                exportOneItem(item);
                            }, style: {
                                padding: '2px 8px',
                                fontSize: '11px',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                background: '#f5f5f5',
                                cursor: 'pointer',
                            } }, "TXT"),
                        React.createElement("span", { onClick: () => toggleExpand(idx, 'first'), style: {
                                cursor: 'pointer',
                                fontSize: '1.3em',
                                lineHeight: 1,
                                display: 'inline-block',
                                transform: ((_b = expandedItems[idx]) === null || _b === void 0 ? void 0 : _b.firstLevel)
                                    ? 'rotate(180deg)'
                                    : 'rotate(0deg)',
                                transition: 'transform 0.2s',
                            } }, "\uD83D\uDD3D"))),
                React.createElement("div", { style: { marginTop: '6px', fontSize: '0.85em' } },
                    React.createElement("p", { style: { margin: '2px 0' } },
                        React.createElement("strong", null, "Site:"),
                        " ",
                        item.request.site),
                    React.createElement("p", { style: { margin: '2px 0' } },
                        React.createElement("strong", null, "Chain:"),
                        " ",
                        item.request.chain || 'steem'),
                    React.createElement("p", { style: { margin: '2px 0' } },
                        React.createElement("strong", null, "User:"),
                        " ",
                        item.request.username),
                    React.createElement("p", { style: { margin: '2px 0' } },
                        React.createElement("strong", null, "Operation:"),
                        ' ',
                        isMulti
                            ? `${(_d = (_c = res === null || res === void 0 ? void 0 : res.operations) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0} operations`
                            : item.request.action),
                    React.createElement("p", { style: { margin: '2px 0' } },
                        React.createElement("strong", null, "Status:"),
                        ' ',
                        res && (React.createElement("strong", { style: {
                                color: res.status === 'Ok' ? 'green' : 'red',
                            } }, res.status)),
                        !res && React.createElement("span", { style: { color: '#999' } }, "Unkown"))),
                ((_e = expandedItems[idx]) === null || _e === void 0 ? void 0 : _e.firstLevel) && res && (React.createElement(React.Fragment, null,
                    React.createElement("hr", { style: {
                            margin: '12px 0',
                            borderTop: '1px solid #ddd',
                        } }),
                    React.createElement("div", { style: { fontSize: '0.85em', lineHeight: '1.5' } },
                        React.createElement("p", { style: {
                                margin: '8px 0',
                                fontWeight: 'bold',
                                fontSize: '0.95em',
                            } },
                            "Description: ",
                            res.description),
                        React.createElement("div", { style: {
                                margin: '12px 0',
                                padding: '10px',
                                background: '#fff',
                                borderRadius: '6px',
                                border: '1px solid #e0e0e0',
                            } },
                            res.block_num != null && res.trx_num != null && (React.createElement("p", { style: { margin: '4px 0' } },
                                React.createElement("strong", null,
                                    "Block Number/Transaction Number:",
                                    ' '),
                                ' ',
                                React.createElement("a", { href: `https://steemworld.org/block/${res.block_num}/${res.block_num}-${res.trx_num}`, target: "_blank", rel: "noopener noreferrer", style: { color: '#1976d2' } },
                                    res.block_num,
                                    "/",
                                    res.trx_num))),
                            res.id && (React.createElement("p", { style: { margin: '4px 0' } },
                                React.createElement("strong", null, "Tran. ID:"),
                                ' ',
                                (() => {
                                    const chain = (item.request.chain || 'steem').toLowerCase();
                                    const explorers = {
                                        hive: `https://hivexplorer.com/tx/${res.id}`,
                                        blurt: `https://blocks.blurtwallet.com/#/tx/${res.id}`,
                                        steem: `https://steemworld.org/block/${res.block_num}/${res.id}`,
                                    };
                                    const url = explorers[chain] || explorers.steem;
                                    return (React.createElement("a", { href: url, target: "_blank", rel: "noopener noreferrer", style: {
                                            color: '#1976d2',
                                            textDecoration: 'underline',
                                        } },
                                        React.createElement("span", { style: {
                                                fontSize: '0.9em',
                                                fontFamily: 'monospace',
                                                wordBreak: 'break-all',
                                            } }, res.id)));
                                })())),
                            res.ref_block_num != null && (React.createElement("p", { style: { margin: '4px 0' } },
                                React.createElement("strong", null, "Ref Block Num: "),
                                " ",
                                res.ref_block_num)),
                            res.ref_block_prefix != null && (React.createElement("p", { style: { margin: '4px 0' } },
                                React.createElement("strong", null, "Ref Block Prefix: "),
                                ' ',
                                res.ref_block_prefix)),
                            res.trx_num != null && (React.createElement("p", { style: { margin: '4px 0' } },
                                React.createElement("strong", null, "Transaction Number: "),
                                " ",
                                res.trx_num))),
                        isMulti && (React.createElement("div", { style: {
                                display: 'flex',
                                alignItems: 'center',
                                marginTop: '12px',
                            } },
                            React.createElement("strong", { style: { color: '#1976d2' } },
                                "Operations (",
                                res.operations.length,
                                ")"),
                            React.createElement("span", { onClick: () => toggleExpand(idx, 'second'), style: {
                                    marginLeft: 'auto',
                                    cursor: 'pointer',
                                    fontSize: '1.4em',
                                    transform: ((_f = expandedItems[idx]) === null || _f === void 0 ? void 0 : _f.secondLevel)
                                        ? 'rotate(180deg)'
                                        : 'rotate(0deg)',
                                    transition: 'transform 0.2s',
                                } }, "\uD83D\uDD3D"))),
                        ((_g = expandedItems[idx]) === null || _g === void 0 ? void 0 : _g.secondLevel) &&
                            isMulti &&
                            res.operations && (React.createElement(React.Fragment, null,
                            React.createElement("hr", { style: {
                                    margin: '12px 0',
                                    borderTop: '1px dashed #ccc',
                                } }),
                            React.createElement("div", { style: { marginTop: '4px' } }, res.operations.map((op, i) => (React.createElement("div", { key: i, style: {
                                    margin: '6px 0',
                                    padding: '8px',
                                    background: '#fff',
                                    border: '1px solid #ddd',
                                    borderRadius: '8px',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                                } },
                                React.createElement("div", { style: {
                                        fontWeight: 'bold',
                                        color: '#1976d2',
                                        marginBottom: '4px',
                                        fontSize: '0.95em',
                                    } },
                                    i + 1,
                                    ". ",
                                    op.type),
                                Object.entries(op)
                                    .filter(([k]) => k !== 'type')
                                    .map(([k, v]) => (React.createElement("div", { key: k, style: {
                                        marginLeft: '8px',
                                        marginBottom: '2px',
                                        wordBreak: 'break-word',
                                    } },
                                    React.createElement("strong", null,
                                        k,
                                        ":"),
                                    " ",
                                    String(v)))))))))))))));
        })))));
};
const connector = connect(null, { navigateTo });
export default connector(HistoryPage);
